export default __webpack_public_path__ + "static/media/contact.a8ec43cb.svg";